import { createFormAction } from 'redux-form-saga'
export const FORM_KEY = 'EVENT_FORM'
export const EventFormAction = createFormAction(FORM_KEY)